import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.limitedCompanyError.title',
        defaultMessage: 'Please check your company details again'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.limitedCompanyError.message',
        defaultMessage:
            "We couldn't find your limited company status in Companies House. {messageCheckDetailsLink} whether you've given the right details then try again."
    },
    messageCheckDetailsLink: {
        id: '_.automatedLendingDecision.decisionError.limitedCompanyError.messageCheckDetailsLink',
        defaultMessage: 'Check'
    }
});
